function networkStatusReducer(state = true, action = { onLine: true }) {
  if (action.type === 'NETWORK_STATUS') {
    return action.onLine;
  }

  return state;
}

export default networkStatusReducer;
